import {post,get} from './Tools';

const login = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}auth/signin`, { email: payload.email, password: payload.password, company: payload.company }, {auth: false});
  return response;
};

const getAllCompanies = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_compania/public/get/list`);
  return response;
};

export { login, getAllCompanies };
